const auth = {
    // Common
    email: 'E-mail',
    password: 'Wachtwoord',
    submit: 'Verzenden',
    loading: 'Laden...',
    error: 'Fout',
    success: 'Succes',

    // Form validation
    emailRequired: 'E-mail is verplicht',
    emailInvalid: 'Voer een geldig e-mailadres in',
    passwordRequired: 'Wachtwoord is verplicht',
    confirmPasswordRequired: 'Bevestig je wachtwoord',

    // OAuth
    continueWithGoogle: 'Doorgaan met Google',
    orContinueWithEmail: 'Of ga verder met e-mail',

    // Signup
    signup: 'Registreren',
    signupTitle: 'Registratie',
    signupSubtitle: 'Maak een nieuw account',
    alreadyHaveAccount: 'Heb je al een account?',
    loginLink: 'Inloggen',
    signupSuccess: 'Registratie succesvol voltooid!',
    signupError: 'Fout tijdens registratie',
    login: 'Inloggen',
    loginTitle: 'Inloggen',
    loginSubtitle: 'Voer je e-mail en wachtwoord in',
    dontHaveAccount: 'Heb je geen account?',
    signupLink: 'Registreren',
    forgotPassword: 'Wachtwoord vergeten?',
    loginSuccess: 'Inloggen succesvol voltooid!',
    loginError: 'Fout tijdens inloggen',
    passwordReset: 'Wachtwoord Resetten',
    passwordResetTitle: 'Wachtwoord Resetten',
    passwordResetSubtitle: 'Voer je e-mail in om je wachtwoord te resetten',
    sendResetEmail: 'Verstuur Reset E-mail',
    backToLogin: 'Terug naar Inloggen',
    resetEmailSent: 'Reset e-mail verzonden!',
    resetEmailError: 'Fout bij verzenden reset e-mail',
    newPassword: 'Nieuw Wachtwoord',
    confirmPassword: 'Bevestig Wachtwoord',
    resetPassword: 'Wachtwoord Resetten',
    resetting: 'Resetten...',
    passwordResetSuccess: 'Wachtwoord succesvol gereset! Doorverwijzen naar inloggen...',
    passwordResetError: 'Fout tijdens resetten wachtwoord',
    passwordResetErrorUnverified: 'Kan wachtwoord niet resetten. Verifieer eerst je e-mailadres.',
    resendVerificationEmail: 'Verificatie E-mail Opnieuw Verzenden',
    verificationEmailSent: 'Verificatie e-mail verzonden!',
    verificationEmailError: 'Fout bij verzenden verificatie e-mail',
    passwordMismatch: 'Wachtwoorden komen niet overeen',
    passwordsDoNotMatch: 'Wachtwoorden komen niet overeen',
    passwordTooShort: 'Wachtwoord moet minimaal 6 tekens zijn',
    passwordMinLength: 'Gelieve deze tekst te verlengen tot 6 tekens of meer (je gebruikt momenteel {current} tekens).',
    fieldRequired: 'Dit veld is verplicht.',

    // Email Verification
    emailVerification: 'E-mail Verificatie',
    verifyingEmail: 'Je e-mailadres wordt geverifieerd...',
    verifying: 'Verifiëren...',
    emailNotVerified: 'Verifieer je e-mail voordat je inlogt. Controleer je inbox voor de verificatielink.',

    // Google OAuth
    googleAuthentication: 'Google Authenticatie',
    processingGoogleAuth: 'Google authenticatie wordt verwerkt...',
    processing: 'Verwerken...',
    googleAuthSuccess: 'Google authenticatie succesvol voltooid!',
    googleAuthFailed: 'Google authenticatie mislukt.',
    googleAuthFailedWithCredentials: 'Google authenticatie mislukt. Controleer je gegevens en probeer opnieuw.',
    googleAuthCancelled: 'Google authenticatie geannuleerd of mislukt.',
    googleNoCode: 'Geen autorisatiecode ontvangen van Google.',
    googleAuthFailedMessage: 'Google authenticatie mislukt. Je kunt opnieuw proberen of terugkeren naar inloggen.',
    tryAgain: 'Probeer Opnieuw'
};

export default auth;

